import { render, staticRenderFns } from "./Shelter.vue?vue&type=template&id=4a4f404b&"
import script from "./Shelter.vue?vue&type=script&lang=js&"
export * from "./Shelter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports